/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ParentSize } from "@visx/responsive";
import {
  BrickLoader,
  StackBarChart,
  Granularity,
  Period,
  LoaderWrap,
  ChartType as ChartTypeComponents,
} from "~/components";
import { TopGroupsCostChartProps } from "~/components/Charts/CostAnalysis";
import { EstatePeriod } from "~/constants";

type Props = {
  loading: boolean;
  startDate: string;
  endDate: string;
  granularity: Granularity;
  data: TopGroupsCostChartProps[];
  period: EstatePeriod | Period;
  colors: { [k: string]: string };
  keys: string[];
  chartType: ChartTypeComponents | undefined;
};

export function EstateRecordsGroupingChart({
  loading,
  data,
  granularity,
  startDate,
  endDate,
  period,
  colors,
  keys,
  chartType,
}: Props) {
  return (
    <LoaderWrap loading={loading} Component={BrickLoader}>
      <ParentSize>
        {(parent) => (
          <>
            <StackBarChart
              showOthers
              width={parent.width}
              height={280}
              data={data}
              granularity={granularity}
              loading={loading}
              startDate={startDate}
              endDate={endDate}
              period={period}
              colors={colors}
              chartType={chartType}
              keys={keys}
            />
          </>
        )}
      </ParentSize>
    </LoaderWrap>
  );
}
